<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import { CricketIncidentId } from '@collector/sportsapi-client-legacy'
import Button from '@mobile/components/Button/Button.vue'
import { useIncidentAction } from '@mobile/views/Relation/Shared/Popup/useIncidentAction'
import { ProbableLinkedParticipant } from '@mobile/views/Relation/Shared/RelationDependencies/types'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

export default defineComponent({
  components: {
    Button,
  },
  props: {
    probableLinkedParticipant: {
      type: [Object, null] as PropType<ProbableLinkedParticipant | null>,
      required: true,
    },
  },
  emits: ['substitutionAdded'],
  setup(props, { emit }) {
    const participant = computed(
      () => props.probableLinkedParticipant?.getParticipant().value || null,
    )
    const eventInjections = useEventInjections()
    const backgroundColor = computed(
      () => props.probableLinkedParticipant?.css.bgClass || 'bg-white',
    )

    function addSubstitution(): void {
      if (!participant.value || !props.probableLinkedParticipant) {
        return
      }

      emit('substitutionAdded', {
        probableLinkedParticipant: props.probableLinkedParticipant,
        incidentActionSubstitution: useIncidentAction(eventInjections, {
          incident_id: CricketIncidentId.Substitution,
          participant_team_id: participant.value.id,
        }),
      })
    }

    return {
      backgroundColor,
      addSubstitution,
    }
  },
})
</script>

<template>
  <div
    class="flex space-x-4 rounded-md p-1"
    :class="backgroundColor"
  >
    <Button
      class="m-auto mx-1 h-8 w-8"
      :color="'green'"
      :size="'xs'"
      :disabled="!probableLinkedParticipant"
      @click="addSubstitution"
    >
      <FontAwesomeIcon
        class="rotate-45 transform"
        icon="times"
      />
    </Button>

    <div class="flex flex-1 space-x-6">
      <div class="flex flex-1 items-center text-xs">
        <span v-if="!probableLinkedParticipant">
          Select team to add substitution
        </span>
        <span
          v-else
          class="font-bold"
          :class="{
            'text-home brightness-50':
              probableLinkedParticipant.side === 'home',
            'text-away brightness-[3]':
              probableLinkedParticipant.side === 'away',
          }"
        >
          <div>Click on "+" button to send substitution and assign players</div>
        </span>
      </div>
    </div>
  </div>
</template>
